export const CONNECTION_CACHE_KEY = '__connection';

export const WalletId = {
  iota: 'IOTA Wallet',
  iotaSnap: 'IOTA MetaMask Snap',
  nightly: 'Nightly',
  cosmostation: 'Cosmostation Wallet',
};

export type WalletId = (typeof WalletId)[keyof typeof WalletId];
